import './_loginPage.less'
import React from 'react'

import { Typography, Button, Form, Input, Grid } from 'antd'
import Breadcrumb from 'components/Breadcrumb'
import MainCard from 'components/MainCard'
import { Link } from 'react-router-dom'

import { validationHelpers } from '../../helpers'
import { useLoginForm } from '../../hooks/useLoginForm'

const { rules } = validationHelpers

const LoginPage: React.FC = () => {
  const { form, onSubmit, phoneNumber } = useLoginForm()
  const screens = Grid.useBreakpoint()

  return (
    <div className="login-page">
      <Breadcrumb items={['Trang chủ', 'Đăng ký vay']} />

      <Form
        form={form}
        name="login-form"
        validateTrigger="onChange"
        onFinish={onSubmit}
        scrollToFirstError
      >
        <div className="login-page--form">
          <MainCard>
            <Typography.Title className="text-common-title">Số điện thoại</Typography.Title>

            <Form.Item
              name="phoneNumber"
              className="mb-0"
              rules={rules.phoneNumber}
              initialValue=""
            >
              <Input
                placeholder="Nhập số điện thoại của bạn"
                maxLength={10}
                size="large"
                type="tel"
              />
            </Form.Item>
          </MainCard>

          <div className="text-right">
            {screens.md && (
              <Link to="/">
                <Button className="mr-16" type="primary" ghost>
                  Quay lại
                </Button>
              </Link>
            )}

            <Button
              type="primary"
              htmlType="submit"
              disabled={!phoneNumber}
              block={!screens.md}
              id={[window.location.pathname, 'next'].join('--').replace('/', '')}
            >
              Tiếp theo
            </Button>
          </div>
        </div>
      </Form>
    </div>
  )
}

export default React.memo(LoginPage)
